<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <Navbar />
    <div class="messages-page">
      <el-card shadow="always" class="messages-card">
        <template #header>
          <h2>Messages privés</h2>
        </template>
        <el-empty
          v-if="loaded && conversations.length === 0"
          description="Aucune conversation. Envoyez un message depuis la page d'un membre."
        />
        <ul v-else class="conversation-list">
          <li
            v-for="conversation in conversations"
            :key="conversation.user.id"
            class="conversation-item"
            @click="openConversation(conversation.user.id)"
          >
            <el-avatar :size="40" :src="getProfilePictureUrl(conversation.user.profile_picture)" />
            <div class="conversation-body">
              <div class="conversation-head">
                <span class="username"><UserLink :username="conversation.user.username" /></span>
                <span class="date">{{ formatDate(conversation.lastMessage.createdAt) }}</span>
              </div>
              <p class="excerpt">
                <span v-if="conversation.lastMessage.isMine" class="you">Vous : </span>{{ excerpt(conversation.lastMessage.content) }}
              </p>
            </div>
          </li>
        </ul>
      </el-card>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import UserLink from '@/components/UserLink.vue'
import api, { API_BASE_URL } from '@/api'
import { notifyError } from '@/notify'

export default {
  components: {
    Navbar,
    UserLink,
  },

  data() {
    return {
      conversations: [],
      loaded: false,
    }
  },

  async created() {
    await this.fetchConversations()
  },

  mounted() {
    document.body.style.backgroundColor = 'rgba(21, 109, 123)'
  },

  methods: {
    async fetchConversations() {
      try {
        const response = await api.get('/message/conversations')
        this.conversations = (response.data && response.data.conversations) || []
      } catch (error) {
        notifyError(error, 'Impossible de charger les conversations')
      } finally {
        this.loaded = true
      }
    },

    openConversation(userId) {
      this.$router.push({ name: 'Conversation', params: { userId } })
    },

    getProfilePictureUrl(path) {
      return `${API_BASE_URL}/${path}`
    },

    excerpt(text) {
      if (!text) return ''
      return text.length > 80 ? `${text.slice(0, 80)}…` : text
    },

    formatDate(dateString) {
      const options = { day: 'numeric', month: 'short', hour: 'numeric', minute: 'numeric' }
      return new Date(dateString).toLocaleDateString('fr-FR', options)
    },
  },
}
</script>

<style scoped>
.messages-page {
  padding: 70px 20px 20px;
  max-width: 700px;
  margin: 0 auto;
}

.messages-card h2 {
  margin: 0;
  color: #303133;
}

.conversation-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.conversation-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 8px;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
}

.conversation-item:hover {
  background: #f5f7fa;
}

.conversation-body {
  flex: 1;
  min-width: 0;
}

.conversation-head {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.username {
  font-weight: 600;
  color: #303133;
}

.date {
  font-size: 12px;
  color: #909399;
}

.excerpt {
  margin: 4px 0 0;
  color: #606266;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.you {
  color: #909399;
}
</style>
